import * as React from 'react';
const classNames = require('classnames');

import { Button } from '../components/buttons';
import { Spinner } from '../components/common';
import { TextArea, TextInput } from '../components/forms';
import Utils, { Validation, InputError } from '../common/utils';

interface Props {
	className?: string;
	form: any;
	onFormChange: (e: any) => void;
	onPhoneKeyUp: (e: any) => void;
	onSubmit: () => void;
	loading: boolean;
}
interface State {
	touched: {
		email: boolean;
	};
}
class ClaimForm extends React.Component<Props, State> {
	errors = { email: {} as InputError };

	constructor(props: Props) {
		super(props);
		this.state = {
			touched: {
				email: false
			}
		};
	}

	handleBlur = (field: any) => (evt: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true }
		});
	}

	isSubmitDisabled = () => {
		if (!this.props.form.name || !this.props.form.phone || !this.props.form.deceasedName) {
			return true;
		}

		if (this.props.form.email !== '') {
			const errors = this.validate();
			return errors.email.hasError;
		}

		if (this.props.loading) {
			return true;
		}

		return false;
	}

	validate = () => {
		// true means invalid
		return {
			email: Validation.validateEmail(this.props.form.email)
		};
	}

	render() {
		this.errors = this.validate();
		return (
			<div className={classNames('', this.props.className)}>
				<h2 className="form-fieldset-title">Your contact info</h2>
				<div className="form-fieldset">
					<div className="row">
						<TextInput
							id="claimantName"
							labelText="Your name"
							name="name"
							onChange={this.props.onFormChange}
							value={this.props.form.name}
							className="col-md-6"
							required={true}
						/>
						<TextInput
							id="claimantPhone"
							labelText="Phone"
							name="phone"
							onChange={this.props.onFormChange}
							onKeyUp={this.props.onPhoneKeyUp}
							value={this.props.form.phone}
							className="col-md-6"
							required={true}
						/>
						<TextInput
							id="claimantEmail"
							labelText="Email"
							name="email"
							onBlur={this.handleBlur('email')}
							onChange={this.props.onFormChange}
							value={this.props.form.email}
							className="col-md-12 mb-2"
							error={Utils.shouldMarkError(this.errors.email, this.state.touched.email) ? this.errors.email : undefined}
						/>
					</div>
				</div>
				<h2 className="form-fieldset-title mt-4">Policy info</h2>
				<div className="form-fieldset">
					<div className="row">
						<TextInput
							id="claimPolicyNumber"
							labelText="Policy #"
							name="policyNumber"
							onChange={this.props.onFormChange}
							value={this.props.form.policyNumber}
							className="col-md-6 mb-md-2"
						/>
						<TextInput
							id="claimDeceasedName"
							labelText="Name of insured"
							name="deceasedName"
							onChange={this.props.onFormChange}
							value={this.props.form.deceasedName}
							className="col-md-6 mb-2"
							required={true}
						/>
					</div>
				</div>
				<h2 className="form-fieldset-title mt-4">Additional info</h2>
				<div className="form-fieldset">
					<TextArea
						id="claimComments"
						labelText="Comments"
						name="comments"
						onChange={this.props.onFormChange}
						value={this.props.form.comments}
						className="mb-2"
					/>
				</div>
				<Button onClick={this.props.onSubmit} className="btn-primary mt-4" disabled={this.isSubmitDisabled()}>
					Begin claim process {this.props.loading && <Spinner />}
				</Button>
			</div>
		);
	}
}
export default ClaimForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/claim/ClaimForm.tsx